const CashierTypes = {
    FETCH_START:    '[CASHIER] FETCH START',
    FETCH_SUCCESS:  '[CASHIER] FETCH SUCCESS',
    FETCH_FAILURE:  '[CASHIER] FETCH FAILURE'
};

export default CashierTypes;